import React, { Component } from "react";
import { connect } from "react-redux";
import { setMainMenuItems, toggleMainMenu } from "../../../Redux/slices/menu";

import { Link, NavLink } from "react-router-dom";
import DarkOverlay from "../../DarkOverlay";
import Dropdown from "../../Dropdown";
import { CartIcon } from "../Icons";

const mapStateToProps = state => {
    return {
        visible: state.menu.mainMenu.visible,
        menuItems: state.menu.mainMenu.items
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setMainMenuItems: payload => dispatch(setMainMenuItems(payload)),
        toggleMainMenu: payload => dispatch(toggleMainMenu(payload))
    }
}

class Menu extends Component {
    componentDidMount() {
        this.props.setMainMenuItems(window.appMenus["main-menu"]);
    }

    render() {
        var menuItems = this.props.menuItems.map(item => {
            return <NavLink exact to={item.path} key={item.order} className="menu-item" onClick={() => this.props.toggleMainMenu(false)}>
                {item.label}
            </NavLink>
        });

        var menuFooterItems = [];

        for (var x = 0; x < window.appMenus["footer-menu"].length; x++) {
            var item = window.appMenus["footer-menu"][x];
            if (item.path !== "#") {
                menuFooterItems.push({
                    label: item.label,
                    path: item.path
                });
            }
        }

        var menuFooterMenu = menuFooterItems.map(item => {
            return <Link to={item.path} key={item.label}>{item.label}</Link>;
        });

        return <DarkOverlay top={0} visible={this.props.visible} closeSelf={() => this.props.toggleMainMenu(false)}>
            <div className="menu-wrap transform-fade-x fade-x-left">
                <div className="close-wrap" onClick={() => this.props.toggleMainMenu(false)}>
                    <span className="title">Menu</span>
                    <div className="close-icon"></div>
                </div>

                <div className="currency-cart-wrap">
                    <Dropdown>
                        <a href="?currency=SEK">Svensk krona (SEK)</a>
                        <a href="?currency=EUR">Euro (EUR)</a>
                        <a href="?currency=USD">Dollar (USD)</a>
                        <a href="?currency=GBP">Brittish Pound (GBP)</a>
                    </Dropdown>

                    <a href="/checkout" className="cart-icon-wrap">
                        <CartIcon />
                    </a>
                </div>

                <div className="menu-items-wrap">
                    {menuItems}
                </div>

                <div className="menu-items-footer-wrap">
                    {menuFooterMenu}
                </div>
            </div>
        </DarkOverlay>
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);